// extracted by mini-css-extract-plugin
export var colorSquare = "_nt-0";
export var container = "_nt-h";
export var danger = "_nt-5";
export var lightPink = "_nt-8";
export var neutralBlue = "_nt-7";
export var neutralYellow = "_nt-6";
export var normal = "_nt-1";
export var primary = "_nt-2";
export var primaryLight = "_nt-3";
export var selected = "_nt-i";
export var solidBlack = "_nt-g";
export var solidGreen = "_nt-b";
export var solidLightBlue = "_nt-d";
export var solidNavy = "_nt-c";
export var solidOrange = "_nt-f";
export var solidPink = "_nt-e";
export var solidRed = "_nt-9";
export var solidYellow = "_nt-a";
export var success = "_nt-4";